<div class="services-area ptb-30">

    <div class="container">
        <div class="section-title">
            <h4 class="welcome-text">{{ 'Features' | translate }}</h4>
        </div>
        <div class="container">
            <div class="row justify-content-center">
                <!--data-aos="flip-left"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="2000"-->
                <div class="col-lg-3 col-sm-6 transition">
                    <div class="single-services">
                        <div class="icon">
                            <img src="assets/img/icon/support.png" alt="Image">
                        </div>
                        <h3>{{'Shop_Online' | translate }}</h3>
                        <p>{{'Easy_and_simple_shopping' | translate }}</p>
                    </div>
                </div>
                <!--data-aos="flip-left"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="2100"-->
                <div class="col-lg-3 col-sm-6 transition">
                    <div class="single-services">
                        <div class="icon">
                            <img src="assets/img/icon/delivery.png" alt="Image">
                        </div>
                        <h3>{{'Fast_Delivery' | translate }}</h3>
                        <p>{{'Fast_delivery_according_to_the_date_of_the_event' | translate }}</p>
                    </div>
                </div>
                <!--data-aos="flip-left"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="2200"-->
                <div class="col-lg-3 col-sm-6 transition">
                    <div class="single-services">
                        <div class="icon">
                            <img src="assets/img/icon/network.png" alt="Image">
                        </div>
                        <h3>{{'New_Products' | translate }}</h3>
                        <p>{{'Classy_gifts_that_keep_pace_with_the_times' | translate }}</p>
                    </div>
                </div>
                <!--data-aos="flip-left"
         data-aos-easing="ease-out-cubic"
         data-aos-duration="2300"-->
                <div class="col-lg-3 col-sm-6 transition">
                    <div class="single-services">
                        <div class="icon">

                            <img src="assets/img/icon/payment.png" alt="Image">

                        </div>
                        <h3>{{'Secured_Payments' | translate }}</h3>
                        <p>{{'100%_secure_payment_via_the_Thawani_platform' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

